module.exports = __webpack_public_path__ + "static/modesta-pd-7a7ad18a7c362313157c52bf277465c1.png";